const content: { [key: string]: string } = {
  loading: "Connecting to Academy...",
  error: "Unable to connect to Academy. Please try again.",
  goBack: "Return",
};

export default content;
